export default {
  OPEN: "open",
  Rr: "purchase",
  kr: "push_click",
  Ee: "custom_event",
  Qr: "iam_click",
  vs: "test",
};
